export default __webpack_public_path__ + "static/media/product-image-card-4.3f7ff7d6.jpg";